export var RsvpStatusOptions;
(function (RsvpStatusOptions) {
    RsvpStatusOptions[RsvpStatusOptions["YES_ONLY"] = 0] = "YES_ONLY";
    RsvpStatusOptions[RsvpStatusOptions["YES_AND_NO"] = 1] = "YES_AND_NO";
})(RsvpStatusOptions || (RsvpStatusOptions = {}));
//# sourceMappingURL=RsvpCollectionConfig.js.map